import { useTranslation } from "react-i18next";
import { Button, Modal } from "semantic-ui-react";

import "modules/ManufacturerDashboard/components/ManufacturerConfirmRequestModal/ManufacturerConfirmRequestModal.scss";

type ManufacturerConfirmRequestModalTypes = {
  showConfirmModal: boolean;
  onCloseModal: () => void;
  onCreateRequest: () => void;
  onHandleRequestReason: (input: string) => void;
  isConfirmButtonDisabled: boolean;
};

export const ManufacturerConfirmRequestModal = ({
  showConfirmModal,
  onCloseModal,
  onCreateRequest,
  onHandleRequestReason,
  isConfirmButtonDisabled
}: ManufacturerConfirmRequestModalTypes) => {
  const { t } = useTranslation();

  return (
    <Modal open={showConfirmModal} size="tiny">
      <Modal.Header className="Manufacturer__ConfirmModal-header">{t("v8_confirmation_required", "Confirmation required")}</Modal.Header>
      <Modal.Content className="Manufacturer__ConfirmModal-content">
        <span>{t("v8_enter_reason_for_asking_access", "Enter reason for asking access.")}</span>
        <textarea onChange={e => onHandleRequestReason(e.target.value)} />
      </Modal.Content>
      <Modal.Actions className="Manufacturer__ConfirmModal-actions">
        <Button onClick={onCloseModal} basic>
          {t("v8_cancel", "Cancel")}
        </Button>
        <Button className="Manufacturer__ConfirmModal-actions--confirmBtn" disabled={isConfirmButtonDisabled} onClick={onCreateRequest}>
          {t("v8_confirm", "Confirm")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
